import {
  PAYWALL_COOKIE,
  VOCUSER_COOKIE
} from '../constants';

const
  {Cookies} = window,
  UserType  = Object.freeze({
    ANONYMOUS:  'anonimo',
    REGISTERED: 'registrado',
    SUBSCRIBER: 'suscriptor',
    TRIAL:      'trial'
  })
;

const User = {
  getUserType() {
    var userType, paywall, pwUserType, vocUid, cookie;

    vocUid   = decodeURIComponent(Cookies.get(VOCUSER_COOKIE));
    cookie   = vocUid === 'undefined' ? {} : _jsonParse(vocUid);
    userType = UserType.ANONYMOUS; // <'anonimo' | 'registrado' | 'trial' | 'suscriptor'>
    paywall  = Cookies.get(PAYWALL_COOKIE);
    if (paywall) {pwUserType = paywall.split('|').pop();}

    if (pwUserType) {
      userType = pwUserType;
    } else if (cookie.uid) {
      userType = UserType.REGISTERED;
    }

    return userType;
  }
};

export default User;

/* Private */

function _jsonParse(vocUid) {
  var result;

  try {
    result = JSON.parse(vocUid);
  } catch (e1) {
    // NOTE: fix issue https://agil.vocento.com/browse/MEC-2575
    vocUid = vocUid.replace(/\+/g, '');
    try {
      result = JSON.parse(vocUid);
    } catch (e2) {
      result = {};
    }
  }

  return result;
}



// WEBPACK FOOTER //
// ./src/mixins/user.js